module.exports = __webpack_public_path__ + "img/ANG.beb2f2f0.svg";